import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DbService } from '../db.service';
import { TeammatesTableDataSource, TeammatesTableItem } from './teammates-table-datasource';

@Component({
  selector: 'app-teammates-table',
  templateUrl: './teammates-table.component.html',
  styleUrls: ['./teammates-table.component.css']
})
export class TeammatesTableComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TeammatesTableItem>;
  @Input() playerId: string;
  dataSource: TeammatesTableDataSource;
  public isEmptyTable$: Observable<Boolean>;


  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
 'playerName',
 'dateOfBirth',
 'placeOfBirth',
 'season',
 'atTeam'];


  constructor (
    private dbService: DbService
  ) { }
  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */

  ngOnInit() {
    this.dataSource = new TeammatesTableDataSource(this.playerId, this.dbService);
    this.isEmptyTable$ = this.dataSource.dataLength$.pipe(
      map(dataLength => dataLength == 0)
    );
    
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }
}
